import axios from 'axios';

/**
 * Instancia de Axios pre-configurada para apuntar a la base de la API.
 * Detecta automáticamente si está en desarrollo (localhost) o producción.
 */
const hostname = window.location.hostname;
const devHosts = ['localhost', '127.0.0.1'];
const apiBase = devHosts.includes(hostname)
  ? `${window.location.protocol}//${hostname}:8000/api`
  : '/api';
const backendBase = devHosts.includes(hostname)
  ? `${window.location.protocol}//${hostname}:8000`
  : window.location.origin;

const api = axios.create({
  baseURL: apiBase,
});

/**
 * Interceptor para agregar el token de autenticación a todas las solicitudes.
 */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Genera la URL correcta para archivos del storage de Laravel.
 * 
 * @param {string | null} relativeUrl La ruta relativa del archivo (ej: /storage/downloads/imagen.jpg).
 * @returns {string | null} La URL funcional para usar en tags <img>, <a>, etc.
 */
export const getImageUrl = (relativeUrl) => {
  if (!relativeUrl) {
    return null;
  }
  
  // Si ya es una URL completa, retornarla directamente
  if (relativeUrl.startsWith('http://') || relativeUrl.startsWith('https://')) {
    return relativeUrl;
  }

  // Si la URL es relativa (p.ej. /storage/imagenes/xxx.jpg), la transformamos a una absoluta
  // usando el host del backend configurado más arriba.
  const normalized = relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`;
  return `${backendBase}${normalized}`;
};

export default api;